interface UrlResponse {
  shortId: string;
  longUrl: string;
}

export class UrlError extends Error {
  constructor(
    message: string,
    public readonly code: number = 500,
    public readonly details?: unknown
  ) {
    super(message);
    this.name = 'UrlError';
  }
}

export class UrlService {
  private static readonly BASE_URL = 'https://tracking-waffle-v2.theo-110.workers.dev/utils';

  public static async getLongUrl(shortId: string): Promise<string> {
    try {
      if (!shortId) {
        throw new UrlError('ID da URL curta é obrigatório', 400);
      }

      const response = await fetch(`${this.BASE_URL}/url/${shortId}`);
      
      if (!response.ok) {
        if (response.status === 404) {
          throw new UrlError('URL curta não encontrada', 404);
        }
        throw new UrlError('Erro ao buscar URL', response.status);
      }

      const data: UrlResponse = await response.json();
      return data.longUrl;
    } catch (error) {
      if (error instanceof UrlError) {
        throw error;
      }

      throw new UrlError('Erro inesperado ao processar URL curta');
    }
  }
} 